import { ref, onMounted, onUnmounted } from 'vue';
import useDisplay from '~/composables/filteringFacets/useDisplay';

export default function useScrollSticky(onlyMobile, scrollDir) {
  const showSticky = ref(false);
  let lastScrollPosition;

  function onScroll() {
    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    if (currentScrollPosition < 0) {
      return;
    }

    if (scrollDir === 'up') {
      showSticky.value = currentScrollPosition <= lastScrollPosition;
    } else if (scrollDir === 'down') {
      showSticky.value = currentScrollPosition >= lastScrollPosition;
    }
    lastScrollPosition = currentScrollPosition;
  }

  if (onlyMobile) {
    onMounted(() => {
      const { updateDisplay, screen } = useDisplay();
      updateDisplay();
      if (screen.value.isMobile) {
        window.addEventListener('scroll', onScroll);
      }
    });
    onUnmounted(() => window.removeEventListener('scroll', onScroll));
  } else {
    onMounted(() => window.addEventListener('scroll', onScroll));
    onUnmounted(() => window.removeEventListener('scroll', onScroll));
  }

  return {
    showSticky,
  };
}
